export default "__VITE_ASSET__97e1dc98__"